<script setup lang="ts">
import type { DisciplineFilePack } from '../model/interfaces'

import { faPenToSquare, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useDisciplineFilePackActions } from '../model/discipline-file-pack-actions.hook'

defineOptions({
  name: 'DisciplineFilePackActions',
})

const props = defineProps<{
  pack: DisciplineFilePack
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManageFiles,
  toggle,
  openEdit,
  openDelete,
} = useDisciplineFilePackActions({
  pack: computed(() => props.pack),
})
</script>

<template>
  <div
    ref="containerRef"
    class="discipline-file-pack-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for file pack ${pack.id}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="discipline-file-pack-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit files"
          color="blue"
          :prepend-icon="faPenToSquare"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="canManageFiles"
          text="Delete files"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineTaskActions.scss" />
